<template>
	<div class="ModuleBoxRegister" v-if="Visible">
		<div class="ModuleBoxRegisterBody">
			<div class="ModuleBoxRegisterBodyTop">
				<div class="ModuleBoxRegisterBodyTopLogo">
					<el-image :src="ImageLogoUrl" fit="scale-down" />
				</div>
				<div class="ModuleBoxRegisterBodyTopCloseBtn" @click="onHide()">
					<el-icon><Close /></el-icon>
				</div>
			</div>
			<div class="ModuleBoxRegisterBodyBody">
				<div class="ModuleBoxRegisterBodyBodyBody">
					<el-form 
						:model="RegisterForm" 
						:rules="RegisterRules" 
						ref="RegisterFormRef" 
						label-width="0"
					>
						<div class="ModuleBoxRegisterBodyBodyBodyItem">
							<div class="ModuleBoxRegisterBodyBodyBodyItemTitle">注册账号</div>
							<div class="ModuleBoxRegisterBodyBodyBodyItemBody">
								<el-form-item prop="Username">
									<el-input v-model="RegisterForm.Username" placeholder="请输入注册账号" />
								</el-form-item>
							</div>
						</div>
						<div class="ModuleBoxRegisterBodyBodyBodyItem">
							<div class="ModuleBoxRegisterBodyBodyBodyItemTitle">注册密码</div>
							<div class="ModuleBoxRegisterBodyBodyBodyItemBody">
								<el-form-item prop="Password">
									<el-input type="password" v-model="RegisterForm.Password" placeholder="请输入注册密码" />
								</el-form-item>
							</div>
						</div>
						<div class="ModuleBoxRegisterBodyBodyBodyItem">
							<div class="ModuleBoxRegisterBodyBodyBodyItemTitle">确认密码</div>
							<div class="ModuleBoxRegisterBodyBodyBodyItemBody">
								<el-form-item prop="Password2">
									<el-input type="password" v-model="RegisterForm.Password2" placeholder="请输入确认密码" />
								</el-form-item>
							</div>
						</div>
						<div class="ModuleBoxRegisterBodyBodyBodyItem">
							<div class="ModuleBoxRegisterBodyBodyBodyItemTitle">验证码</div>
							<div class="ModuleBoxRegisterBodyBodyBodyItemBody" style="display: flex;">
								<el-form-item prop="Captcha" style="width: 100%;">
									<el-input v-model="RegisterForm.Captcha" placeholder="请输入验证码" />
								</el-form-item>
								<div class="ModuleBoxRegisterBodyBodyBodyItemBodyCaptcha" @click="ResetCaptcha()">
									<Sidentify ref="Captcha" :identifyCode="CaptchaValue"></Sidentify>
								</div>
							</div>
						</div>
						<div class="ModuleBoxRegisterBodyBodyBodyButton">
							<div class="ModuleBoxRegisterBodyBodyBodyButtonRegisterBtn" @click="RegisterSubmit()">提交注册</div>
							<div class="ModuleBoxRegisterBodyBodyBodyButtonBackBtn" @click="onBack()">我有账号，直接登录</div>
						</div>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>
<script>
  import index from "./index-Js";
  export default index;
</script>
